<div id="page" class="col-lg-12 fadeIn fast">
    <div style="text-align:center; margin-top: 60px;">
        <h4><u><b><i>REPORTE ESTADISTICO</i></b></u></h4>
    </div>

    <div id="fechadesdehasta" style="text-align:center;" class="titulos1">
        <div style="text-align:center">
            <mat-form-field>
                <input matInput [matDatepicker]="picker" placeholder="Fecha desde" [value]="dateValue" (dateInput)="addEvent('input', $event)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            &nbsp;
            <mat-form-field>
                <input matInput [matDatepicker]="picker2" placeholder="Fecha hasta" [value]="dateValue2" (dateInput)="addEvent2('input', $event)">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>

            <button *ngIf="loading" (click)="calculaSec()" type="button" class="btn btn-info">
                Aplicar.. <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
            </button>
            <button *ngIf="!loading" [disabled]="!fecha_ticket || !fecha_ticket2" (click)="calculaSec()" type="button" class="btn btn-info">
                Aplicar
            </button>
        </div>
        <hr>
        <div class="animated fadeIn" *ngIf="dataSourceSeccionales" id=losfiltros>
            <form class="form-inline">
                <!--filtro seccional-->
                <div class="BOX animated fadeIn">
                    <label class="my-1 mr-2" for="inlineFormCustomSelectPref">Sec-Deleg ({{dataSourceSeccionales.length}})</label>
                    <select (click)="blaUsCueMot(dataSourceUsers); calculaUser();" class="custom-select my-1 mr-sm-2" id="inlineFormCustomSelectPref" [(ngModel)]="filtroSec" name="filtroSec">
                        <option value="TODAS_LAS_SECCIONALES">TODAS_LAS_SECCIONALES</option>
                        <option *ngFor="let sec of dataSourceSeccionales" [ngValue]="sec.IDSEC">{{sec.SECDEL}} ({{sec.TOTAL | currency:"$"}}) </option>
                    </select>
                    <button *ngIf="l_us" (click)="calculaUser()" type="button" class="btn btn-info">
                            Aplicar.. <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                    </button>
                    <button *ngIf="!l_us" (click)="calculaUser()" type="button" class="btn btn-info">
                        Aplicar
                    </button>
                </div>
                <!--filtro usuario si != todas las seccionales-->
                <div class="BOX animated fadeIn" *ngIf="filtroSec != 'TODAS_LAS_SECCIONALES' && dataSourceUsers">
                    <label class="my-1 mr-2" for="inlineFormCustomSelectPref">&nbsp;Usuario</label>
                    <select (click)="calculaCuentas();" class="custom-select my-1 mr-sm-2" id="inlineFormCustomSelectPref" [(ngModel)]="filtroUs" name="filtroUs">
                        <option selected>TODOS_LOS_USUARIOS</option>
                        <option *ngFor="let us of dataSourceUsers" [ngValue]="us.USER">({{us.USER}}) {{us.NOMBRE}} ({{us.TOTAL | currency:"$" }})</option>
                    </select>
                    <button *ngIf="l_cue" (click)="calculaCuentas()" type="button" class="btn btn-info">
                            Aplicando.. <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                    </button>
                    <button *ngIf="!l_cue" (click)="calculaCuentas()" type="button" class="btn btn-info">
                        Aplicar
                    </button>
                </div>

                <!--filtro por cuentas-->
                <div class="BOX animated fadeIn">
                    <label class="my-1 mr-2" for="inlineFormCustomSelectPref">&nbsp;Cuenta Contable</label>
                    <select (click)="calculaMotivos()" class="custom-select my-1 mr-sm-2" id="inlineFormCustomSelectPref" [(ngModel)]="filtroCue" name="filtroCue">
                        <option selected>TODAS_LAS_CUENTAS</option>
                        <option *ngFor="let cue of dataSourceCuentas" [ngValue]="cue.CATEGO">[{{cue.CATEGO}}] {{cue.DETALLECUENTA}} ({{cue.TOTAL | currency:"$" }})</option>
                    </select>
                    <button *ngIf="l_mot" (click)="calculaMotivos()" type="button" class="btn btn-info">
                        Aplicando.. <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                    </button>
                    <button *ngIf="!l_mot" (click)="calculaMotivos()" type="button" class="btn btn-info">
                        Aplicar
                    </button>
                </div>

                <!--filtro motivos-->
                <div class="BOX animated fadeIn">
                    <label class="my-1 mr-2" for="inlineFormCustomSelectPref">&nbsp;Motivo</label>
                    <select class="custom-select my-1 mr-sm-2" id="inlineFormCustomSelectPref" [(ngModel)]="filtroMot" name="filtroMot">
                        <option selected>TODOS_LOS_MOTIVOS</option>
                        <option *ngFor="let mot of dataSourceMotivos" [ngValue]="mot.MOTIVO">{{mot.MOTIVO}} ({{mot.TOTAL | currency:"$"}})</option>
                    </select>
                    <button *ngIf="l_mot" (click)="calculaMotivos()" type="button" class="btn btn-info">
                        Aplicando.. <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                    </button>
                    <button *ngIf="!l_mot" (click)="calculaMotivos()" type="button" class="btn btn-info">
                        Aplicar
                    </button>
                </div>
            </form>
            <hr>

        </div>
        <div style="justify-content: space-between;">
            <button *ngIf="!l_repo" [disabled]="(control==false) || (filtroSec == 'TODAS_LAS_SECCIONALES')" (click)="cargarGrid()" type="button" class="btn btn-warning">
                Generar Reporte
            </button>
            <button *ngIf="l_repo" [disabled]="(control==false) || (filtroSec == 'TODAS_LAS_SECCIONALES')" (click)="cargarGrid()" type="button" class="btn btn-warning">
                Generando..<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
            </button>
            &nbsp;
            <button *ngIf="contGrid > 0" [disabled]="(control==false) || (filtroSec == 'TODAS_LAS_SECCIONALES')" (click)="getRepo()" type="button" class="btn btn-success">
                Exportar a Excel
            </button>
        </div>
        <hr>
    </div>
    <div id="DIVTABLA" *ngIf="contGrid > 0">
        <!--
        <mat-form-field class="TABLITA">
            <input  matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtro">
        </mat-form-field>  
        -->
        <div class="example-container mat-elevation-z8">
            <table class="TABLITA" mat-table [dataSource]="dataSourceGrid" matSort>
                <!-- ID Column -->
                <ng-container matColumnDef="IDSEC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Idsec </th>
                <td mat-cell *matCellDef="let row"> {{row.IDSEC}} </td>
                </ng-container>
            
                <!-- Progress Column -->
                <ng-container matColumnDef="SECDEL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Sec/Deleg </th>
                <td mat-cell *matCellDef="let row"> {{row.SECDEL}} </td>
                </ng-container>
            
                <!-- Name Column -->
                <ng-container matColumnDef="USER">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Dni </th>
                <td mat-cell *matCellDef="let row"> {{row.USER}} </td>
                </ng-container>
            
                <!-- Color Column -->
                <ng-container matColumnDef="NOMBRE">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                <td mat-cell *matCellDef="let row"> {{row.NOMBRE}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="IMPORTE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Importe </th>
                        <td mat-cell *matCellDef="let row"> {{row.IMPORTE | currency:"$"}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="CATEGO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cuenta </th>
                        <td mat-cell *matCellDef="let row"> {{row.CATEGO}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="DETALLECUENTA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Detalle </th>
                        <td mat-cell *matCellDef="let row"> {{row.DETALLECUENTA}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="DESDE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Desde </th>
                        <td mat-cell *matCellDef="let row"> {{row.DESDE}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="HASTA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Hasta </th>
                        <td mat-cell *matCellDef="let row"> {{row.HASTA}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="MOTIVO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Motivo </th>
                        <td mat-cell *matCellDef="let row"> {{row.MOTIVO}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>


    <!-- Modal REPORTE -->
    <div style="margin-top: 100px" class="modal fade" id="MODALREPO" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div id="modito" class="modal-content">
                <div class="modal-header">
                    <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">Generando..</p>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
                </div>
                <div class="modal-body" #REPORTE>
                    <app-loading class="m-5" *ngIf="loading"></app-loading>
                </div>
                <button id="salemodal" hidden type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
            </div>
        </div>
    </div>